import axios from 'axios';

// Report generation and land-cover jobs can take longer than ordinary reads.
export default axios.create({ timeout: 120000 });

export async function fetchWithTimeout(url, options = {}, timeout = 120000, responseType = 'json') {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);
  try {
    const response = await fetch(url, { ...options, signal: controller.signal });
    if (!response.ok) throw new Error('Request failed');
    // Consume the body while the timeout is still active.
    return await response[responseType]();
  } finally {
    clearTimeout(timer);
  }
}
